import { Injectable } from "@angular/core";
import { ObgConfigFeAdaptiveClientCommon } from "@obg/common.config";
import { ConfigService } from "@obg/ngx.global";

const REWARDS_ENDPOINT = "v1/rewards";
const REWARDS_ENDPOINT_V2 = "v2/rewards";
const REWARD_PARAMETERS_SUFFIX = ":type/:identifier";

/**
 * @deprecated [fabric-deprecated] - Use fabric micro-frontends/app-account/types/config/config.model.ts instead
 */
@Injectable({
	providedIn: "root",
})
export class RewardConfigService {
	constructor(private service: ConfigService<ObgConfigFeAdaptiveClientCommon>) {}

	/**
	 * @deprecated [fabric-deprecated] - Use fabric micro-frontends/app-account/types/config/config.model.ts instead
	 */
	getRewardsEndpoint(): string {
		return this.service.get((x) => x.common.reward.endpoints!.rewards, `${REWARDS_ENDPOINT_V2}/`);
	}

	/**
	 * @deprecated [fabric-deprecated] - Use fabric micro-frontends/app-account/types/config/config.model.ts instead
	 */
	getRewardsStateEndpoint(): string {
		return this.service.get((x) => x.common.reward.endpoints!.rewardsState, `${REWARDS_ENDPOINT}/:state/`);
	}

	/**
	 * @deprecated [fabric-deprecated] - Use fabric micro-frontends/app-account/types/config/config.model.ts instead
	 */
	getRewardsUpdateEndpoint(): string {
		return this.service.get(
			(x) => x.common.reward.endpoints!.rewardsUpdate,
			`${REWARDS_ENDPOINT}/${REWARD_PARAMETERS_SUFFIX}/`
		);
	}

	/**
	 * @deprecated [fabric-deprecated] - Use fabric micro-frontends/app-account/types/config/config.model.ts instead
	 */
	getRewardEndpoint(): string {
		return this.service.get(
			(x) => x.common.reward.endpoints!.getReward,
			`${REWARDS_ENDPOINT}/${REWARD_PARAMETERS_SUFFIX}/`
		);
	}

	/**
	 * @deprecated [fabric-deprecated] - Use "document.obgEventBus.dispatch(AccountAppCommand.GetRewardsEnabled)" instead
	 */
	getIsRewardsEnabled(): boolean {
		return this.service.get((x) => x.common.reward.enabled, true);
	}
}
